import PubNubCommon from './pubnub-common';

class PubNubAngular extends PubNubCommon {
  constructor() {
    super(undefined);
  }
}

module.exports = PubNubAngular;

module.exports.PubNubAngular = PubNubAngular;
